import React, { Suspense, useState, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import LandingPage from '../init/AuthLoading/AuthLoadingContainer';
import MapPage from '../ui/pages/Map/MapContainer';
import LoginPage from '../ui/pages/Login/LoginContainer';
import EmailLoginPage from '../ui/pages/EmailLogin/EmailLoginContainer';
import ConfirmEmailPage from '../ui/pages/ConfirmEmail/ConfirmEmailContainer';
import ForgotPage from '../ui/pages/ForgetPassword/ForgotPasswordContainer';
import ForgetEmailPage from '../ui/pages/ForgetEmail/ForgetEmailContainer';
import ResetPasswordPage from '../ui/pages/ResetPassword/ResetPasswordContainer';
import VerifyPhonePage from '../ui/pages/VerifyPhone/VerifyPhoneContainer';
import SignUpPage from '../ui/pages/SignUp/SignupContainer';
import OrgSignUpPage from '../ui/pages/OrgSignUp/OrgSignupContainer';
import LoadingContainer from '../ui/components/LoadingScreen/LoadingContainer';
import AddPhoneContainer from '../ui/pages/onboarding/AddPhone/AddPhoneContainer';
import VerifyPhoneContainer from '../ui/pages/onboarding/VerifyPhone/VerifyPhoneContainer';
import UpdateAddressContainer from '../ui/pages/onboarding/UpdateAddress/UpdateAddressContainer';
import AddSepaContainer from '../ui/pages/onboarding/addPayment/AddSepaPayment/AddSepaContainer';
import SelectPaymentContainer from '../ui/pages/onboarding/addPayment/SelectPayment/SelectPaymentContainer';
import SelectBankContainer from '../ui/pages/onboarding/addPayment/SelectBank/SelectBankContainer';
import SchufaCheckContainer from '../ui/pages/onboarding/SchufaCheck/SchufaCheckContainer';
import AddCCPaymentContainer from '../ui/pages/onboarding/addPayment/AddCCPayment/AddCCPaymentContainer';
import FuelSettingsContainer from '../ui/pages/Rental/FuelSettings/FuelSettingsContainer';
import BrowseDamagesContainer from '../ui/pages/Rental/Damages/Browse/BrowseDamagesContainer';
import AddDamageContainer from '../ui/pages/Rental/Damages/Add/AddDamageContainer';
import AddTestDamageContainer from '../ui/pages/Rental/Damages/AddTest/AddDamageContainer';
import DLOnboardingContainer from '../ui/pages/onboarding/DrivingLicense/Onboarding/DLOnboardingContainer';
import KeyVideoContainer from '../ui/pages/Rental/KeyVideo/KeyVideoContainer';
import RentalHandoverContainer from '../ui/pages/Rental/Handover/RentalHandoverContainer';
import DLScanningContainer from '../ui/pages/onboarding/DrivingLicense/Scanning/DLScanningContainer';
import CardVideoContainer from '../ui/pages/Rental/CardVideo/CardVideoContainer';
import BookingConfirmationContainer from '../ui/pages/Booking/Confirmation/BookingConfirmationContainer';
import BookingContainer from '../ui/pages/Booking/BookingContainer';
import AddCircleContainer from '../ui/pages/Dashboard/circle/AddCircleContainer';
import RentalsPage from '../ui/pages/Dashboard/Rentals/UserRentals/UserRentalsContainer';
import RentalDetailsPage from '../ui/pages/Dashboard/Rentals/RentalDetails/RentalDetailsContainer';
import BalancePage from '../ui/pages/Dashboard/Balance/BalanceContainer';
import ProfilePage from '../ui/pages/Dashboard/Profile/ProfileContainer';
import DesktopDashboardContainer from '../ui/pages/Dashboard/DesktopDashboardContainer';
import { isMobileBrowser } from '../utils';
import {
  isFRM,
  isGRF,
  isKYCApp,
  isMVV,
  isOSN,
  isSCT,
  isUBQ,
  selectDeeplink,
  selectIsEmbedded,
  selectOpenedModal,
  selectShowHomeWT,
  selectUser,
  setDeeplinkUrl,
} from 'getaway-data-layer';
import { useDispatch, useSelector } from 'react-redux';
import DesktopWTContainer from '../ui/pages/DesktopWT/DesktopWTContainer';
import MobileSwitchContainer from '../ui/pages/MobileSwitch/MobileSwitchContainer';
import BookingConsentContainer from '../ui/pages/Booking/Consent/BookingConsentContainer';
import HomeContainer from '../ui/pages/Home/HomeContainer';
import CCAdyenComponent from '../ui/pages/CCAdyenComponent/CCAdyenComponent';
import VerifyEmailContainer from '../ui/pages/onboarding/VerifyEmail/VerifyEmailContainer';
import IDOnboardingContainer from '../ui/pages/onboarding/ID/Onboarding/IDOnboardingContainer';
import IDScanningContainer from '../ui/pages/onboarding/ID/Scanning/IDScanningContainer';
import PaymentLinkContainer from '../ui/pages/Booking/PaymentLink/PaymentLinkContainer';
import OptimizedSepaContainer from '../ui/pages/onboarding/addPayment/OptimizedSepaPayment/OptimizedSepaContainer';
import PaymentProfileContainer from '../ui/pages/onboarding/addPayment/PaymentProfile/PaymentProfileContainer';
import UpdateEmailContainer from '../ui/pages/onboarding/UpdateEmail/UpdateEmailContainer';
import TariffContainer from '../ui/pages/onboarding/Tariff/TariffContainer';
import UpsellingsContainer from '../ui/pages/onboarding/Upsellings/UpsellingsContainer';
import DynamicFormContainer from '../ui/pages/onboarding/DynamicForm/DynamicFormContainer';
import MdPlaygroundContainer from '../ui/pages/MarkdownPlayground/MdPlaygroundContainer';
import AllAroundContainer from '../ui/pages/Rental/AllAround/AllAroundContainer';
import ConsentsContainer from '../ui/pages/Dashboard/consents/ConsentsContainer';
import NotFoundPage from '../ui/pages/NotFound/NotFoundContainer';
import DepositContainer from '../ui/pages/onboarding/Deposit/DepositContainer';
import GrfTariffContainer from '../ui/pages/onboarding/Tariff/GrfTariff/GrfTariffContainer';
import OsnTariffContainer from '../ui/pages/onboarding/Tariff/OsnTariff/OsnTariffContainer';
import AddPinContainer from '../ui/pages/onboarding/AddPin/AddPinContainer';
import TariffPartnerContainer from '../ui/pages/onboarding/TariffPartner/TariffPartnerContainer';
import DoBContainer from '../ui/pages/onboarding/DoB/DoBContainer';
import FrmTariffContainer from '../ui/pages/onboarding/Tariff/FrmTariff/FrmTariffContainer';
import MvvTariffContainer from '../ui/pages/onboarding/Tariff/MvvTariff/MvvTariffContainer';
import SctTariffContainer from '../ui/pages/onboarding/Tariff/SctTariff/SctTariffContainer';
import BubMigrationModal from '../ui/components/bubMigrationModal/BubMigrationModal';
import UbqShutdownModal from '../ui/components/ubqShutdownModal/UbqShutdownModal';

const AppRoute = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const showHomeWT = useSelector(selectShowHomeWT) as boolean;
  const deeplink = useSelector(selectDeeplink);
  const history = useHistory();
  const [hasHandledDeepLink, setHasHandledDeepLink] = useState(false);
  const isEmbedded = useSelector(selectIsEmbedded);
  const isMapFilterOpened = useSelector(selectOpenedModal) === 'MapFilterModal';

  const handleDeeplink = () => {
    const currentPath = history?.location?.pathname || '';
    // Ignore top-level static paths like '/' or '/reset-password' & any subpath starting with '/.well-known/'
    if (
      !user &&
      !['/', '/reset-password', '/reset-password/'].includes(currentPath) &&
      !currentPath.startsWith('/.well-known/')
    ) {
      const newDeeplink =
        history?.location?.pathname + history?.location?.search;
      if (newDeeplink !== '/map') {
        dispatch(setDeeplinkUrl(newDeeplink));
      }
    }
    setHasHandledDeepLink(true);
  };

  useEffect(() => {
    handleDeeplink();
  }, []);

  useEffect(() => {
    if (user && deeplink !== '') {
      dispatch(setDeeplinkUrl(''));
    }
  }, [user]);

  if (!hasHandledDeepLink) {
    return <LoadingContainer />;
  }

  return (
    <Suspense fallback={<LoadingContainer />}>
      {!isEmbedded &&
        isKYCApp() &&
        showHomeWT &&
        history?.location?.pathname === '/' &&
        (isMobileBrowser() ? <HomeContainer /> : <DesktopWTContainer />)}
      {isKYCApp() &&
        isMobileBrowser() &&
        history?.location?.pathname === '/' && <SignUpPage />}
      {isUBQ() && <BubMigrationModal />}
      {isUBQ() && <UbqShutdownModal />}
      <Switch>
        {/* AUTH */}
        <Route path="/login" exact component={LoginPage} />
        <Route path="/email-login" exact component={EmailLoginPage} />
        <Route path="/confirm-email" exact component={ConfirmEmailPage} />
        <Route path="/signup" exact component={SignUpPage} />
        <Route path="/org-signup" exact component={OrgSignUpPage} />
        <Route
          path="/circle/join"
          exact
          component={user ? LandingPage : SignUpPage}
        />
        <Route path="/forgot" exact component={ForgotPage} />
        <Route path="/forget-email" exact component={ForgetEmailPage} />
        <Route path="/verify-phone" exact component={VerifyPhonePage} />
        <Route path="/reset-password" exact component={ResetPasswordPage} />
        <Route path="/markdown" exact component={MdPlaygroundContainer} />

        {/* ON BOARDING */}
        <PrivateRoute
          path="/onboarding/email"
          exact
          component={VerifyEmailContainer}
        />
        <PrivateRoute
          path="/onboarding/updateEmail"
          exact
          component={UpdateEmailContainer}
        />
        <PrivateRoute
          path={'/onboarding/addPhone' || '/dashboard/addPhone'}
          exact
          component={AddPhoneContainer}
        />
        <PrivateRoute
          path="/onboarding/verifyPhone"
          exact
          component={VerifyPhoneContainer}
        />
        <PrivateRoute path="/onboarding/dob" exact component={DoBContainer} />
        <PrivateRoute
          path="/onboarding/addAddress"
          exact
          component={UpdateAddressContainer}
        />
        <PrivateRoute
          path="/onboarding/selectPayment"
          exact
          component={SelectPaymentContainer}
        />
        <PrivateRoute
          path="/onboarding/selectBank"
          exact
          component={SelectBankContainer}
        />
        <PrivateRoute
          path="/onboarding/addCC"
          exact
          component={AddCCPaymentContainer}
        />
        <PrivateRoute
          path="/onboarding/addSepa"
          exact
          component={AddSepaContainer}
        />
        <PrivateRoute
          path="/onboarding/optimizedSepa"
          exact
          component={OptimizedSepaContainer}
        />
        <PrivateRoute
          path="/onboarding/schufa"
          exact
          component={SchufaCheckContainer}
        />
        <PrivateRoute
          path="/onboarding/DLOnboarding"
          exact
          component={DLOnboardingContainer}
        />
        <PrivateRoute
          path="/onboarding/DLScanning"
          exact
          component={DLScanningContainer}
        />
        <PrivateRoute
          path="/onboarding/IDOnboarding"
          exact
          component={IDOnboardingContainer}
        />
        <PrivateRoute
          path="/onboarding/IDScanning"
          exact
          component={IDScanningContainer}
        />
        <PrivateRoute
          path="/onboarding/tariff"
          exact
          component={
            isMVV()
              ? MvvTariffContainer
              : isFRM()
              ? FrmTariffContainer
              : isOSN()
              ? OsnTariffContainer
              : isGRF()
              ? GrfTariffContainer
              : isSCT()
              ? SctTariffContainer
              : TariffContainer
          }
        />
        <PrivateRoute
          path="/onboarding/tariffpartner"
          exact
          component={TariffPartnerContainer}
        />
        <PrivateRoute
          path="/onboarding/upsellings"
          exact
          component={UpsellingsContainer}
        />
        <PrivateRoute
          path="/onboarding/dynamicForm"
          exact
          component={DynamicFormContainer}
        />
        <PrivateRoute
          path="/onboarding/deposit"
          exact
          component={DepositContainer}
        />
        <PrivateRoute
          path="/onboarding/addPin"
          exact
          component={AddPinContainer}
        />

        {/* DASHBOARD */}
        <PrivateRoute
          path="/dashboard/email"
          exact
          component={VerifyEmailContainer}
        />
        <PrivateRoute
          path="/dashboard/updateEmail"
          exact
          component={UpdateEmailContainer}
        />
        <PrivateRoute
          path="/dashboard/addPhone"
          exact
          component={AddPhoneContainer}
        />
        <PrivateRoute
          path="/dashboard/verifyPhone"
          exact
          component={VerifyPhoneContainer}
        />
        <PrivateRoute path="/dashboard/dob" exact component={DoBContainer} />
        <PrivateRoute
          path="/dashboard/joinCircle"
          exact
          component={AddCircleContainer}
        />
        <PrivateRoute
          path="/dashboard/addAddress"
          exact
          component={UpdateAddressContainer}
        />
        <PrivateRoute
          path="/dashboard/selectPayment"
          exact
          component={SelectPaymentContainer}
        />
        <PrivateRoute
          path="/dashboard/selectBank"
          exact
          component={SelectBankContainer}
        />
        <PrivateRoute
          path="/dashboard/addCC"
          exact
          component={AddCCPaymentContainer}
        />
        <PrivateRoute
          path="/dashboard/schufa"
          exact
          component={SchufaCheckContainer}
        />
        <PrivateRoute
          path="/dashboard/addSepa"
          exact
          component={AddSepaContainer}
        />
        <PrivateRoute
          path="/dashboard/optimizedSepa"
          exact
          component={OptimizedSepaContainer}
        />
        <PrivateRoute
          path="/dashboard/optimizedSepa/:id"
          exact
          component={OptimizedSepaContainer}
        />
        <PrivateRoute
          path="/dashboard/DLOnboarding"
          exact
          component={DLOnboardingContainer}
        />
        <PrivateRoute
          path="/dashboard/DLScanning"
          exact
          component={DLScanningContainer}
        />
        <PrivateRoute
          path="/dashboard/IDOnboarding"
          exact
          component={IDOnboardingContainer}
        />
        <PrivateRoute
          path="/dashboard/IDScanning"
          exact
          component={IDScanningContainer}
        />
        <PrivateRoute
          path="/dashboard/paymentProfile/:id"
          exact
          component={PaymentProfileContainer}
        />
        <PrivateRoute
          path="/dashboard/paymentProfile"
          exact
          component={PaymentProfileContainer}
        />
        <PrivateRoute
          path="/dashboard/consents"
          exact
          component={ConsentsContainer}
        />
        <PrivateRoute
          path="/dashboard/tariff"
          exact
          component={
            isMVV()
              ? MvvTariffContainer
              : isFRM()
              ? FrmTariffContainer
              : isOSN()
              ? OsnTariffContainer
              : isGRF()
              ? GrfTariffContainer
              : isSCT()
              ? SctTariffContainer
              : TariffContainer
          }
        />
        <PrivateRoute
          path="/dashboard/tariffpartner"
          exact
          component={TariffPartnerContainer}
        />
        <PrivateRoute
          path="/dashboard/upsellings"
          exact
          component={UpsellingsContainer}
        />
        <PrivateRoute
          path="/dashboard/dynamicForm"
          exact
          component={DynamicFormContainer}
        />
        <PrivateRoute
          path="/dashboard/deposit"
          exact
          component={DepositContainer}
        />
        <PrivateRoute
          path="/dashboard/addPin"
          exact
          component={AddPinContainer}
        />
        <Route
          path="/dashboard/partner-new-password"
          exact
          component={ResetPasswordPage}
        />

        {/* RENTAL */}
        <PrivateRoute
          path="/rental/AllAround"
          exact
          component={AllAroundContainer}
        />
        <PrivateRoute
          path="/rental/fuelSettings"
          exact
          component={FuelSettingsContainer}
        />
        <PrivateRoute
          path="/rental/browseDamages"
          exact
          component={BrowseDamagesContainer}
        />
        <PrivateRoute
          path="/rental/addDamage"
          exact
          component={AddDamageContainer}
        />
        <PrivateRoute
          path="/rental/addTestDamage"
          exact
          component={AddTestDamageContainer}
        />
        <PrivateRoute
          path="/rental/keyVideo"
          exact
          component={KeyVideoContainer}
        />
        <PrivateRoute
          path="/rental/cardVideo"
          exact
          component={CardVideoContainer}
        />
        <PrivateRoute
          path="/rental/handover"
          exact
          component={RentalHandoverContainer}
        />

        <Route
          path="/booking/confirmation"
          exact
          component={BookingConfirmationContainer}
        />

        <PrivateRoute path="/booking/:id" exact component={BookingContainer} />

        <PrivateRoute
          path="/booking/payment/:id"
          exact
          component={PaymentLinkContainer}
        />

        <PrivateRoute
          path="/booking/consent/:id"
          exact
          component={BookingConsentContainer}
        />

        {/* ROOT */}
        {!isKYCApp() && (
          <Route
            path="/map"
            exact
            component={
              isMobileBrowser() || isEmbedded
                ? MapPage
                : user
                ? () => null
                : !isMapFilterOpened
                ? DesktopWTContainer
                : () => null
            }
          />
        )}
        <PrivateRoute
          path="/rentalDetails/:id"
          exact
          component={RentalDetailsPage}
        />
        <PrivateRoute path="/rentals" exact component={RentalsPage} />
        <PrivateRoute path="/balance" exact component={BalancePage} />
        <PrivateRoute path="/settings" exact component={ProfilePage} />
        <PrivateRoute path="/settings/services" exact component={ProfilePage} />
        <PrivateRoute path="/adyen/cc" exact component={CCAdyenComponent} />

        <PrivateRoute
          path="/dashboard"
          exact
          component={DesktopDashboardContainer}
        />
        <PrivateRoute path="/mobile" exact component={MobileSwitchContainer} />
        <Route path="/" exact component={LandingPage} />
        <Route path="/*" component={NotFoundPage} />
      </Switch>
    </Suspense>
  );
};

export default AppRoute;
